import { render, staticRenderFns } from "./DashboardFamilyMarket.vue?vue&type=template&id=201b0f73&"
import script from "./DashboardFamilyMarket.vue?vue&type=script&lang=js&"
export * from "./DashboardFamilyMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports